import { Inject, Injectable } from '@angular/core';
import { JSBridgeService } from './core/jsbridge.service';
import { ServerAPI } from './serverapi';

@Injectable({
  providedIn: null
})
export class LegacyListService {

  constructor(public jsBridgeService: JSBridgeService, @Inject('ServerApi') private serverApi: ServerAPI) { }


  public async generateList(historyId: string | undefined = undefined) {
    this.jsBridgeService.getBridgeSync().save();
    let ret = await this.jsBridgeService.generateKopList(historyId);
    let klantNo = this.jsBridgeService.getKlantNo();
    let ret2 = {
      list: '',
      dbl: ''
    }
    if (ret != undefined && klantNo != undefined) {
      let listName = `/working/LST/${klantNo}.LST`;
      if (ret[listName] != undefined) {
        ret2.list = new TextDecoder().decode(ret[listName] as Uint8Array);
      }
      let dblName = `/working/LST/${klantNo}.DBL`;
      if (ret[dblName] != undefined) {
        ret2.dbl = new TextDecoder().decode(ret[dblName] as any);
      }
    }

    return ret2;
  }

}
